import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaCheckCircle, FaTimesCircle, FaHome, FaWallet } from "react-icons/fa";
import logo from "../assets/logo2.png";

export function FundWalletReceipt() {
  const navigate = useNavigate();
  const location = useLocation();
  const { status, amount, walletBalance, newBalance, reference, rrr, message } = location.state || {};

  if (!status || !amount) { navigate("/fund-wallet"); return null; }

  const isSuccess = status === "success";

  return (
    <div className="min-h-screen bg-[#f5f5f0] flex flex-col">
      <nav className="bg-white border-b border-gray-100">
        <div className="max-w-md mx-auto px-4 h-16 flex items-center gap-2.5">
          <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center overflow-hidden shadow-sm border border-gray-100">
            <img src={logo} alt="UCH" className="w-7 h-7 object-contain" />
          </div>
          <p className="font-bold text-gray-900 text-sm">UCH Self Service</p>
        </div>
      </nav>

      <main className="flex-1 max-w-md w-full mx-auto px-4 py-10 flex flex-col items-center justify-center gap-6">
        {/* Status icon */}
        <div className={`w-20 h-20 rounded-full flex items-center justify-center shadow-lg ${isSuccess ? "bg-green-100" : "bg-red-100"}`}>
          {isSuccess
            ? <FaCheckCircle className="text-green-600 w-10 h-10" />
            : <FaTimesCircle className="text-red-600 w-10 h-10" />
          }
        </div>

        <div className="text-center">
          <h1 className={`text-2xl font-black mb-2 ${isSuccess ? "text-green-700" : "text-red-600"}`}>
            {isSuccess ? "Wallet Funded!" : "Funding Failed"}
          </h1>
          <p className="text-gray-500 text-sm">
            {isSuccess ? "Your wallet has been credited successfully." : message || "Please try again."}
          </p>
        </div>

        {isSuccess && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 w-full space-y-3 text-sm">
            <h3 className="font-bold text-gray-900 border-b border-gray-50 pb-3 mb-1">Transaction Details</h3>
            {[
              ["Amount Deposited", `₦${Number(amount).toLocaleString("en-NG", { minimumFractionDigits: 2 })}`],
              ["Previous Balance", `₦${Number(walletBalance || 0).toLocaleString("en-NG", { minimumFractionDigits: 2 })}`],
              ["New Balance", `₦${Number(newBalance || walletBalance + amount || 0).toLocaleString("en-NG", { minimumFractionDigits: 2 })}`],
              ...(reference ? [["Reference", reference]] : []),
              ...(rrr ? [["RRR", rrr]] : []),
            ].map(([k, v]) => (
              <div key={k} className="flex justify-between">
                <span className="text-gray-500">{k}</span>
                <span className={`font-semibold ${k === "New Balance" ? "text-[#0d3d2e]" : "text-gray-900"} text-right break-all max-w-[55%]`}>{v}</span>
              </div>
            ))}
          </div>
        )}

        <div className="flex gap-3 w-full">
          <button onClick={() => navigate("/dashboard")}
            className="flex-1 flex items-center justify-center gap-2 bg-[#0d3d2e] hover:bg-[#0a3226] text-white font-semibold py-3.5 rounded-xl transition text-sm">
            <FaHome className="w-4 h-4" /> Dashboard
          </button>
          {!isSuccess && (
            <button onClick={() => navigate("/fund-wallet")}
              className="flex-1 flex items-center justify-center gap-2 border border-gray-200 bg-white hover:bg-gray-50 text-gray-700 font-semibold py-3.5 rounded-xl transition text-sm">
              <FaWallet className="w-4 h-4" /> Try Again
            </button>
          )}
        </div>
      </main>
    </div>
  );
}
